import { useServices } from 'containers/services';
import { useQuery, type UseQueryOptions, type UseQueryResult } from 'react-query';
import { QUERY_KEYS } from 'utils/queryKeys';
import type { SerializedManufacturer } from '@enmon/commons/lib/tools';
import type { GetOneManufacturerArg } from '../../../lib/services';

export const useOneManufacturer = (
  manufacturerId: GetOneManufacturerArg['manufacturerId'],
  options?: UseQueryOptions<SerializedManufacturer, Error>,
): UseQueryResult<SerializedManufacturer> => {
  const { manufacturersApiClient } = useServices();

  return useQuery({
    queryKey: QUERY_KEYS.manufacturers.one(manufacturerId),
    queryFn: async ({ signal }) => await manufacturersApiClient.findOne({ manufacturerId, signal }),
    ...options,
  });
};
